"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VOID_ELEMENTS = void 0;
exports.VOID_ELEMENTS = [
    'area',
    'base',
    'br',
    'col',
    'command',
    'embed',
    'hr',
    'img',
    'input',
    'keygen',
    'link',
    'meta',
    'param',
    'source',
    'track',
    'wbr'
];
